import { render, staticRenderFns } from "./ctf-rich-text.vue?vue&type=template&id=74087d10&scoped=true&"
import script from "./ctf-rich-text.vue?vue&type=script&lang=js&"
export * from "./ctf-rich-text.vue?vue&type=script&lang=js&"
import style0 from "./ctf-rich-text.vue?vue&type=style&index=0&id=74087d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74087d10",
  null
  
)

export default component.exports